import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FileModel} from '../../models/file/file.model';


@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    imports: [],
    styleUrls: ['./file-upload.component.sass']
})
export class FileUploadComponent {
    base64File: string | ArrayBuffer | null = null;

    /** Max size in bytes; default to null */
    @Input() maxFileSize: number | null = null //2 * 1024 * 1024; for 2MB

    /** Allowed mime types */
    @Input() allowedMimeTypes: string[] = [
        'image/png', 'image/jpeg', 'application/pdf'
    ];

    /** Flags & emitters */
    @Input() useBase64Upload = true;
    @Input() base64WithInfos = false;
    @Input() isIdFileChange = false;
    @Output() fileSelected = new EventEmitter<any>();
    @Output() idFileChangeEmitter = new EventEmitter<any>();

    /** For showing an error below the upload area */
    fileError: string | null = null;

    onFileSelected(event: Event): void {
        this.fileError = null;
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) {
            return;
        }

        const file = input.files[0];
        if (!this.checkFile(file)) {
            return;
        }

        this.processFile(file);
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        this.fileError = null;
        const dt = event.dataTransfer;
        if (!dt?.files?.length) {
            return;
        }

        const file = dt.files[0];
        if (!this.checkFile(file)) {
            return;
        }

        this.processFile(file);
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
    }

    private checkFile(file: File): boolean {
        if (!this.allowedMimeTypes.includes(file.type)) {
            this.fileError = `Der Dateityp “${file.type}” ist hier nicht erlaubt.`;
            return false;
        }
        if (this.maxFileSize) {
            if (file.size > this.maxFileSize) {
                const mb = (this.maxFileSize / 1024 / 1024).toFixed(1);
                this.fileError = `Die Datei ist zu groß, Sie können maximal ${mb} MB hochladen`;
                return false;
            }
        }
        return true;
    }

    private processFile(file: File) {
        // Emit ID‐change event if needed
        if (this.isIdFileChange) {
            this.idFileChangeEmitter.emit(file);
        }

        // Either convert to base64 or emit raw file
        if (this.useBase64Upload) {
            this.convertFileToBase64(file);
        } else {
            this.fileSelected.emit(file);
        }
    }

    private convertFileToBase64(file: File): void {
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = reader.result as string;
            this.base64File = dataUrl.split(',')[1];
            if (this.base64WithInfos) {
                const payload: FileModel = {
                    fileName: file.name,
                    fileData: this.base64File,
                    mimeType: file.type
                };
                this.fileSelected.emit(payload);
            } else {
                this.fileSelected.emit(this.base64File);
            }
        };
        reader.readAsDataURL(file);
    }
}
